import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { DagSourceModel } from "@app/workflow-common/services/DagSourceModel";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { ConditionalBlockModel } from "@app/workflow-common/services/models/ConditionalBlockModel";
var ConditionalBlockWidgetComponent = /** @class */ (function () {
    function ConditionalBlockWidgetComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.close = new EventEmitter();
        this.hasBranch = false;
        this.nodeOptions = undefined;
        this.conditionalBlockData = {};
        this.isFormSubmitted = false;
        this.showDeleteBtn = false;
        this.select2Instance = undefined;
        this.inputModel = undefined;
    }
    ConditionalBlockWidgetComponent.prototype.ngOnInit = function () {
        this.conditionalBlockData = this.dagSourceModel.getBlocksSource().getBlockByKey(this.blockObject.key);
        var blockObject = tslib_1.__assign({}, this.blockObject);
        var modelData = blockObject['model'] ? blockObject['model'] : undefined;
        if (modelData) {
            this.showDeleteBtn = true;
        }
        this.inputModel = new ConditionalBlockModel(modelData);
        this.fields = Object.values(this.dagSourceModel.getFieldMetadata());
        this.form = this.formBuilder.group({
            col_name: new FormControl(this.inputModel.col_name, [Validators.required]),
        });
        //console.log('conditional',this.conditionalBlockData, blockObject, this.inputModel);
        //console.log('conditional',this.fields);
    };
    ConditionalBlockWidgetComponent.prototype.closeModal = function () {
        this.close.emit({
            action: 'close',
            data: null
        });
    };
    ConditionalBlockWidgetComponent.prototype.remove = function () {
        this.close.emit({
            action: 'remove_block',
            data: this.blockObject
        });
    };
    ConditionalBlockWidgetComponent.prototype.setSelect2Instance = function (event) {
        this.select2Instance = event;
        if (this.hasBranch) {
            this.select2Instance.select2('enable', false);
        }
    };
    ConditionalBlockWidgetComponent.prototype.save = function () {
        this.isFormSubmitted = true;
        var blockObject = tslib_1.__assign({}, this.blockObject);
        var col_name = this.form.get('col_name') ? this.form.get('col_name').value : null;
        if (col_name) {
            var selectedField = this.fields.find(function (f) { return f.col_name === col_name; });
            var fieldType = selectedField.fieldType;
            blockObject.model = new ConditionalBlockModel({
                col_name: col_name, fieldType: fieldType
            });
        }
        this.close.emit({
            action: 'save_and_close',
            data: blockObject
        });
    };
    return ConditionalBlockWidgetComponent;
}());
export { ConditionalBlockWidgetComponent };
